export default $ => {
  const detectScreen = () => {
    const width = $(window).width();
    let device;

    for (device in window.app.breakpoints) {
      if (width > window.app.breakpoints[device]) {
        return device;
      }

      window.app.device = device;
    }

    return device;
  };

  $(window).on('resize', detectScreen);
  detectScreen();
};



// WEBPACK FOOTER //
// ./assets/js/component/responsive.js